module.exports = __webpack_public_path__ + "img/serviced.ef6a20d4.png";